import { defineKey } from '@ha/intl';

import {
  ListingKind,
  ListingType,
  ListingState,
} from '@ha/api/v2/types/Listing';

import { TypeValue } from 'ha/types/SearchFilters';

export const ListingTypeTranslations: Record<ListingType, string> = {
  [ListingType.House]: defineKey('House'),
  [ListingType.Building]: defineKey('Building'),
  [ListingType.Apartment]: defineKey('Apartment'),
};

export const ListingKindTranslations: Record<ListingKind, string> = {
  [ListingKind.EntirePlace]: defineKey('Entire place'),
  [ListingKind.PrivateRoom]: defineKey('Private room'),
  [ListingKind.SharedRoom]: defineKey('Shared room'),
};

export const ListingStateTranslations: Record<ListingState, string> = {
  [ListingState.DRAFT]: defineKey('Draft'),
  [ListingState.PUBLISHED]: defineKey('Published'),
  [ListingState.UNPUBLISHED]: defineKey('Unpublished'),
};

export const PropertyTypeTranslations = {
  HOUSE: defineKey('House'),
  BUILDING: defineKey('Building'),
  APARTMENT: defineKey('Apartment'),
  STUDIO: defineKey('Studio'),
  PRIVATE_ROOM: defineKey('Private room'),
  SHARED_ROOM: defineKey('Shared room'),
};

export const EntirePlaceTypeTranslations = {
  [ListingType.House]: defineKey('Entire house'),
  [ListingType.Building]: defineKey('Entire building'),
  [ListingType.Apartment]: defineKey('Entire apartment'),
};

export const CategoriesTranslations = {
  [TypeValue.PRIVATE_ROOM]: defineKey('Rooms'),
  [TypeValue.SHARED_ROOM]: defineKey('Rooms'),
  [TypeValue.APARTMENT]: defineKey('Apartments'),
  '': defineKey('Accommodation'),
};
